export async function validateLocationRelocationsUseCase(pallet_epc, relocationRepository) {
    const result = await relocationRepository.validate_location(pallet_epc);

    const valid = new relocationRepository.model_validate_location(result.data.data);

    if (!valid.isValid()) {
        throw new Error("pallet epc inválido");
    }
    
    return result;
}